<template>
    <v-dialog
        v-model="dialog"
        max-width="1000"
        :content-class="hasAnyVideo ? 'spillard-dialog': 'spillard-dialog overflow-visible'"
    >

        <v-card>
            <div class="close" @click="dialog = !dialog">
                <i class="material-icons">close</i>
            </div>
            <div class="info-block">
                Remote playback
            </div>
            <v-card-text>
                <div class="loading" v-if="loading">
                    <v-progress-circular
                        :size="30"
                        color="rgba(255, 255, 255)"
                        indeterminate
                    ></v-progress-circular>
                    Loading...
                </div>

                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >

                    <v-container fluid>
                        <v-layout row>
                            <v-flex md3>
                                <div class="label">Choose date</div>
                                <v-menu
                                    ref="isDatePickerShow"
                                    class="choose-date-field"
                                    v-model="isDatePickerShow"
                                    :close-on-content-click="false"
                                    lazy
                                    :attach="attach.chooseDate"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="form.dateString"
                                            label="Picker in menu"
                                            append-icon="event"
                                            readonly
                                            v-on="on"
                                            outline
                                            required
                                            single-line
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker class="green-bg" v-model="form.dateString" :events="events" :allowed-dates="availableDates" no-title scrollable>
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex md3>
                                <div class="label">Choose time</div>
                                <v-menu
                                    ref="isDatePickerShow"
                                    class="choose-time-field"
                                    v-model="isTimePickerShow"
                                    :close-on-content-click="false"
                                    :attach="attach.chooseTime"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="form.time"
                                            label="Picker in menu"
                                            append-icon="event"
                                            readonly
                                            v-on="on"
                                            outline
                                            required
                                            single-line
                                            @change="timePickerChange"
                                        ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-model="form.time"
                                        format="24hr"
                                    ></v-time-picker>
                                </v-menu>
                                <div class="error--text" v-if="isWrongDateRange">
                                    Wrong data range!
                                </div>
                            </v-flex>
                            <v-flex md3>
                                <div class="label">Video length</div>
                                <v-text-field
                                    label="minutes"
                                    single-line
                                    :mask="videoLengthMask"
                                    v-model="videoLength"
                                    outline
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex md3>
                                <div class="label">Select channels</div>
                                <v-select
                                    label="Select channels..."
                                    v-model="selectedChannels"
                                    :items="availableChannels"
                                    item-value="id"
                                    item-text="key"
                                    multiple
                                    attach
                                    outline
                                    single-line
                                    hide-details
                                    @input="limitSelectedChannels"
                                ></v-select>
                            </v-flex>
                            <v-flex md3>
                                <sp-button v-if="!isStreaming" @click.native="requestRemotePlayback" :disabled="availableChannels.length === 0 || selectedChannels.length === 0" sp-class="no-padding-right" small-icon icon="arrow-left" text="Request"></sp-button>
                                <sp-button v-if="isStreaming" @click.native="stopStreaming" sp-class="no-padding-right" small-icon icon="arrow-left" text="Stop"></sp-button>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <div class="slider">
                                <vue-slider v-model="sliderValue" :min="0" :max="1440" tooltip="none" class="transparent" @change="sliderChange" />
                                <div class="videos-availability">
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="none" viewBox="0 0 1440 40">
                                        <rect width="10" height="30" v-for="(item, index) in timeline" v-bind:key="index" :x="index * 1" :fill="item ? '#AED51B': '#FF2B55'"></rect>
                                    </svg>
                                </div>
                            </div>
                        </v-layout>
                        <v-layout row>
                            <v-flex md12 class="text-xs-right">

                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>

                <v-container fluid class="container" v-if="media.list.length > 0">
                    <v-layout v-if="media.type === 0" row wrap>
                        <v-flex md6 class="video-section" v-for="media in media.list" :key="`${media.channelFlag}_${media.url}`">
                            <video-mpeg
                                v-show="media.uri != null"
                                :channel-number="media.channelFlag"
                                :url="media.uri"
                                :tracks="media.overlayUris"
                                is-live-stream
                                @numberLoadedVideo="numberLoadedVideo"
                                :is-video-loaded="isVideoLoaded"
                            ></video-mpeg>
                        </v-flex>
                    </v-layout>
                    <v-layout v-else row wrap>
                        <v-flex md6 class="video-section" v-for="media in media.list" :key="`${media.channelFlag}_${media.url}`">
                            <video-player-hls :channelName="getChannels.find(channel => channel.id === media.channelFlag).key" :url="media.uri"></video-player-hls>
                        </v-flex>
                    </v-layout>
                </v-container>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment'
import VueSlider from 'vue-slider-component'
import SpButton from '@/components/forms/Button'
import 'videojs-flash'
import 'videojs-contrib-hls'
import VideoPlayerHls from '@/views/Journeys/components/VideoPlayerHls'
import toast from '@/plugins/izitoast'
import { StreamingApi } from '@/api'
import VideoMPEG from '@/components/atoms/VideoMPEG'
import { mapGetters } from 'vuex'

const streamingApi = new StreamingApi()

export default {
    name: 'RemotePlayback',
    mounted () {
        this.form.dateString = moment(this.dateInJourneyTab, 'YYYY-MM-DD').format('YYYY-MM-DD')
    },
    components: {
        SpButton,
        VideoPlayerHls,
        VueSlider,
        'video-mpeg': VideoMPEG
    },
    data () {
        return {
            dialog: false,
            valid: false,
            sliderValue: 0,
            loading: false,
            isDatePickerShow: false,
            isTimePickerShow: false,
            isWrongDateRange: false,
            videoLength: 10,
            videoLengthMask: '###',
            availableVideos: [],
            timeline: [],
            events: [],
            showPlayers: false,
            hasContent: false,
            attach: {
                chooseDate: null,
                chooseTime: null
            },
            form: {
                dateString: '',
                time: '00:00'
            },
            selectedChannels: [],
            availableChannels: [],
            media: {
                type: null,
                list: []
            },
            playerOptions: {
                techOrder: ['html5', 'flash'],
                flash: {
                    mediaDataSource: {
                        isLive: true,
                        cors: true,
                        withCredentials: false
                    }
                }
            },
            channels: [],
            availableDays: [],
            search: '',
            isStreaming: false,
            isChannelsChecked: false,
            isError: false,
            loadingStreaming: false,
            loadingFiles: false,
            startDate: moment(this.dateInJourneyTab, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            startTime: '',
            endDate: '',
            time: [],
            percentPerTime: 0,
            maxAvailableDate: '',
            isVideoLoaded: false,
            counter: 0
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        vehicleUuid: {
            required: true
        },
        activeDevice: {
            required: true
        },
        isHardwareOnline: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getSubscribedVehicle: 'mediaModule/getSubscribedVehicle',
            getChannels: 'dictionaryModule/getChannels',
            dateInJourneyTab: 'trackingModule/getDateInJourneyTab'
        }),
        result: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', this.dialog)
            }
        },
        computedStartDate () {
            return moment(`${this.form.dateString} ${this.form.time}`).format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
        },
        computedEndDate () {
            return moment(`${this.form.dateString} ${this.form.time}`).add(this.videoLength ? this.videoLength : 10, 'minutes').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
        },
        hasAnyVideo () {
            return 0 < this.media.list.length
        }
    },
    watch: {
        value: {
            handler () {
                this.dialog = this.value
            }
        },
        dialog (val) {
            if (!val) {
                this.stopStreaming()
            } else {
                if (0 === this.availableDays.length) {
                    this.getCalendar()
                }
            }
            this.$emit('input', this.dialog)
        },
        'form.dateString' (newVal, oldVal) {
            this.isChannelsChecked = false
            this.isStreaming = false
            this.selectedChannels = []
            this.availableVideos = []

            this.getActiveChannels()
        },
        'form.time' (val) {
            let split = val.split(':')
            let hours = parseInt(split[0])
            let minutes = parseInt(split[1])

            this.sliderValue = (hours * 60) + minutes
        },
        computedStartDate (value) {
            this.getCurrentChannels(value)
        }
    },
    methods: {
        parseAvailableVideos () {
            const startOfToday = moment.utc(this.form.dateString).utc(true)
            const endOfToday = moment.utc(this.form.dateString).utc(true).endOf('day')
            this.timeline = []

            if (!this.availableVideos || 0 === this.availableVideos.length) return

            for (let i = 0; 1440 > i; i++) {
                this.timeline[i] = false
            }

            this.availableVideos.forEach(period => {
                let startDate = moment(period.startTime).utc(true)
                let endDate = moment(period.endTime).utc(true)

                if (startDate.isBefore(startOfToday)) startDate = startOfToday
                if (endDate.isAfter(endOfToday)) endDate = endOfToday

                let diff = endDate.diff(startDate, 'minutes')

                let startMinutes = (startDate.hours() * 60) + startDate.minutes()
                for (let i = startMinutes; i < startMinutes + diff; ++i) {
                    this.timeline[i] = true
                }
            })
        },
        sliderChange (val) {
            let minutes = val % 60
            let hours = (val - minutes) / 60

            this.form.time = ('00' + hours).slice(-2) + ':' + ('00' + minutes).slice(-2)
        },
        timePickerChange (val) {

        },
        limitSelectedChannels (val) {
            if (4 < val.length) {
                toast.error('You can only select 4 channels')
                val.pop()
            }
        },
        async getFiles () {
            this.isError = false
            this.loadingFiles = true
            const response = await streamingApi.requestFiles(
                this.activeDevice.hardwareId,
                2,
                this.channels.reduce((a, b) => a + b.id, 0),
                this.form.dateString ? moment(this.form.dateString).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            )

            if (!response.isSuccess || !response.payload) {
                this.loadingFiles = false
                this.isError = true
                return
            }

            this.availableVideos = response.payload.files
            this.getCurrentChannels(this.computedStartDate)
            this.isChannelsChecked = true
            this.loadingFiles = false
            this.loading = false
        },
        getCurrentChannels (value) {
            const currentTime = moment(value)
            const currentlyAvailableVideos = this.availableVideos.filter(video => {
                const startTime = moment(video.startTime).utc(true)
                const endTime = moment(video.endTime).utc(true)
                return currentTime.isBetween(startTime, endTime)
            })

            const currentlyAvailableChannels = [...new Set(currentlyAvailableVideos.map(video => video.channel))]
            this.availableChannels = this.channels.filter(channel => currentlyAvailableChannels.includes(channel.id))
            this.selectedChannels = this.availableChannels.map(elem => {
                return elem.id
            })
        },
        async getActiveChannels () {
            this.loading = true
            const channelsFlag = (this.activeDevice.channelFlag >>> 0).toString(2).split('').reverse()
            const channels = this.getChannels.filter((channel) => {
                return 0 != channel.id
            }).filter((channel, index) => {
                if (0 == channelsFlag[index] || null == channelsFlag[index]) {
                    return
                }

                return channel.id == Math.pow(2, index)
            })

            await this.getFiles()
            this.parseAvailableVideos()

            const availableChannels = [...new Set(this.availableVideos.map(video => video.channel))]

            this.channels = channels.filter(channel => availableChannels.includes(channel.id))
            this.selectedChannels = this.channels.slice(0, 4).map((elem) => {
                return elem.id
            })
            this.loading = false
        },
        async requestRemotePlayback () {
            if (this.loadingStreaming || this.loadingFiles) {
                return
            }

            this.loading = true
            this.loadingStreaming = true
            this.isError = false

            const parsedStartDate = new Date(`${this.form.dateString} ${this.form.time}`).toISOString()
            const endDate = new Date(`${this.form.dateString} ${this.form.time}`)
            const preparedEndDate = new Date(endDate)
            preparedEndDate.setMinutes(Number(endDate.getMinutes()) + Number((this.videoLength ? this.videoLength : 10)))
            const parsedEndDate = preparedEndDate.toISOString()

            const response = await streamingApi.requestPlayback(
                this.activeDevice.hardwareId,
                2,
                this.selectedChannels.reduce((a, b) => a + b, 0),
                parsedStartDate,
                parsedEndDate
            )

            if (!response.isSuccess) {
                this.loadingStreaming = false
                this.loading = false
                this.isError = true
                return
            }

            if (0 !== response.payload.statusCode) {
                this.handleRequestError(response.payload.statusCode)
                this.loading = false
                return
            }

            this.isStreaming = true
            this.loadingStreaming = false
            this.loading = false

            this.media.type = response.payload.standardType
            response.payload.urls.forEach((item) => {
                this.media.list.push({
                    channelFlag: item.channel,
                    uri: item.url
                })
            })
        },
        handleRequestError (statusCode) {
            this.loadingStreaming = false
            this.isError = true

            switch (statusCode) {
                case 1:
                    toast.error('The device has been disconnected, try again later')
                    return
                case 2:
                    toast.error('The device has timed out, try again later')
                    return
                case 3:
                    toast.error('There has been an error, try again later')
                    return
                case 4:
                    toast.error('The device is Busy, try again later')
                    return
                case 5:
                    toast.error('No footage has been found on the device')
                    return
                default:
                    toast.error('Unknown error occured, please try again later')
            }
        },
        async stopStreaming () {
            this.loading = true
            this.media.list = []

            await streamingApi.stopPlayback(this.activeDevice.hardwareId)
            this.isStreaming = false
            this.loading = false
        },
        async getCalendar () {
            this.loading = true
            const response = await streamingApi.requestCalendar(
                this.activeDevice.hardwareId,
                2
            )

            if (!response.isSuccess || !response.payload) {
                this.loading = false
                return
            }

            if (0 !== response.payload.statusCode) {
                this.handleRequestError(response.payload.statusCode)
                this.loading = false
                return
            }

            response.payload.availableDays.forEach(date => {
                this.availableDays.push(moment(date).format('YYYY-MM-DD'))
            })

            this.loading = false
        },
        availableDates (val) {
            return this.availableDays.includes(val)
        },
        attachItems () {
            this.attach.chooseDate = document.querySelector('.choose-date-field .v-input')
            this.attach.chooseTime = document.querySelector('.choose-time-field .v-input')
        },
        numberLoadedVideo () {
            this.counter += 1
            this.isVideoLoaded = false
            if (this.media.list.length === this.counter) {
                this.isVideoLoaded = true
                this.counter = 0
            }
        }
    }
}
</script>

<style scoped lang="scss">

::v-deep .overflow-visible {
    overflow: visible !important;
}

.info-block {
    margin-bottom: 20px;
}

.label {
    position: relative;
}

.button {
    position: relative;
    top: 21px;
}

.player {
    position: absolute !important;
    width: 100%;
    height: 60%;
}

.video-section {
    padding: 10px 5px;
}

.loading {
    position: absolute;
    background: rgba(0,0,0,0.8);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $white;

    .v-progress-circular {
        margin-right: 10px;
    }
}

.title {
    text-align: center;
    background: $secondary;
    color: white;
    padding: 13px 0;
    font-weight: bold;
}

 ::v-deep .green-bg {
   .v-date-picker-table .theme--light.v-btn {
        background: rgba($success, 0.5);
    }
    .accent--text.v-btn {
        background: rgba($success, 0.5) !important;
    }
    .v-date-picker-table .theme--light.v-btn.v-btn--disabled {
        background: none;
    }
}

.slider {
    width: 100%;
    position: relative;

    .videos-availability {
        width: 100%;
        position: relative;

        .box {
            width: calc(100% / 1440);
            height: 20px;
            background: $danger;

            &.available {
                background: $success;
            }
        }
    }
}

.close {
    position: absolute;
    top: 18px;
    right: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}
</style>

<style lang="scss">
.video-js {
    width: 100% !important;
    height: 350px !important;
}
</style>
